import { Toaster } from '@roko/ui/components/ui/sonner'
import { createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { StrictMode, Suspense } from 'react'
import { I18nextProvider } from 'react-i18next'

import { Layout } from '@/components/layout/Layout'
import { ThemeProvider } from '@/context/ThemeProvider'
import i18n from '@/translations'
import { NotFoundView } from '@/views/NotFoundView'

const RootLayout = () => {
  return (
    <StrictMode>
      <ThemeProvider>
        <I18nextProvider i18n={i18n}>
          <Layout />
          <Suspense fallback={null}>
            <TanStackRouterDevtools />
          </Suspense>
          {/*<IdleModal />*/}
          <Toaster richColors expand />
        </I18nextProvider>
      </ThemeProvider>
    </StrictMode>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundView,
})
